function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.5 9.586l5.293-5.293 1.414 1.414L8.5 12.414 1.793 5.707l1.414-1.414L8.5 9.586z",
  fill: "#F4F6F8"
});

var SvgToggleButtonChevron = function SvgToggleButtonChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNyAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9Ikljb24iPgo8cGF0aCBpZD0iVmVjdG9yIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTguNTAwMDUgOS41ODU4NkwxMy43OTI5IDQuMjkyOTdMMTUuMjA3MiA1LjcwNzE4TDguNTAwMDUgMTIuNDE0M0wxLjc5Mjk0IDUuNzA3MThMMy4yMDcxNSA0LjI5Mjk3TDguNTAwMDUgOS41ODU4NloiIGZpbGw9IiNGNEY2RjgiLz4KPC9nPgo8L3N2Zz4K";
export { SvgToggleButtonChevron as ReactComponent };